import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightOutlined } from "@ant-design/icons";
import "./styles.scss";

/**
 * QuickActionItem Component - One row of the quick actions card
 *
 * @param {React.ReactNode} icon - Icon in the colored circle on the left
 * @param {string} color - Color of the icon circle: "pink", "orange" or "purple"
 * @param {string} title - Title of the action
 * @param {React.ReactNode} description - Extra information below the title
 * @param {string} link - Route the link on the right navigates to
 * @param {string} linkText - Text of the link on the right
 */
const QuickActionItem = ({ icon, color = "purple", title, description, link, linkText = "View more" }) => {
  return (
    <div className="quick-action-item">
      <span className={`quick-action-item-icon quick-action-item-icon-${color}`}>{icon}</span>

      <div className="quick-action-item-text">
        <span className="quick-action-item-title">{title}</span>
        {/* Long descriptions are cut off, the title shows the full text on hover */}
        {description && (
          <span
            className="quick-action-item-description"
            title={typeof description === "string" ? description : undefined}
          >
            {description}
          </span>
        )}
      </div>

      <Link to={link} className="quick-action-item-link">
        {linkText} <ArrowRightOutlined className="quick-action-item-link-icon" />
      </Link>
    </div>
  );
};

export default QuickActionItem;
